import { render, staticRenderFns } from "./SelectUser.vue?vue&type=template&id=0bc23fdc&"
import script from "./SelectUser.vue?vue&type=script&lang=js&"
export * from "./SelectUser.vue?vue&type=script&lang=js&"
import style0 from "./SelectUser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports